export class ClientUserRole {
    public readonly roleId: number;
    public readonly roleName: string;
    public readonly displayName: string;

    private constructor(roleId: number, roleName: string, displayName: string) {
        this.roleId = roleId;
        this.roleName = roleName;
        this.displayName = displayName;
    }

    public static HiringTeamManager = new ClientUserRole(
        10,
        "HiringTeamManager",
        "Hiring Team Manager"
    );
    public static HiringTeamMember = new ClientUserRole(
        60,
        "HiringTeamMember",
        "Hiring Team Member"
    );

    public static asArray = () => [
        ClientUserRole.HiringTeamManager,
        ClientUserRole.HiringTeamMember,
    ];

    public static fromId = (roleId: number) =>
        ClientUserRole.asArray().find(t => t.roleId === roleId);
}
